export default [
  {
    path: 'sales-reports',
    name: 'report-sales-reports-v2',
    component: () => import('@/view/pages/reports/sales-reports/SalesReportsHub.vue'),
    meta: {
      title: 'Báo cáo bán hàng - CLICKBUY',
    },
  },
];
